import { GridSortModel } from "@mui/x-data-grid";
import { GameWithTagsCount } from "entities/game/types";
import { FilterOption, FilterProps } from "shared/components/Filter";

export type GameRow = {
  id: string;
  name: string;
  displayName: string;
  productName: string;
  tagsCount: number;
  updatedAt: Date | string;
  status: boolean;
};

export type FilterHook = {
  filteredValues: string[];
  setFilteredValues: (options: FilterOption[]) => void;
  filterData: Omit<FilterProps, "title">;
  isDisabledButton?: boolean;
};

export type GamesTableData = {
  data: GameWithTagsCount[];
  rowCount: number;
  onSortModelChange: (fields: GridSortModel) => void;
  paginationModel: { pageSize: number; page: number };
  onPaginationModelChange: (value: { pageSize: number; page: number }) => void;
};

export enum ManagedTranslations {
  GameName = "Game name",
  GameDescription = "Game description",
  GameOptimisedDescription = "Game optimised description",
  GameShortDescription = "Game short description",
  GameFeature = "Game feature",
  Volatility = "Volatility",
  RTPExact = "RTP exact",
  Paylines = "Paylines",
  JackpotType = "Jackpot type",
  LanguageSupport = "Language support",
  Reels = "Reels",
  Rows = "Rows",
  ReleaseDate = "Release date",
  Autoplay = "Autoplay",
  MinStake = "Min stake",
  MaxStake = "Max stake",
  MaxWin = "Max win",
  GameInfoType = "Info type",
  GameInfoValue = "Info value",
}
